import React from "react";
import { useRecoilState } from "recoil";
// import { makeStyles } from "@material-ui/core/styles";
// import Modal from "@material-ui/core/Modal";
// import Backdrop from "@material-ui/core/Backdrop";
// import Fade from "@material-ui/core/Fade";
import { request, gql } from "graphql-request";
// import { collapsedState } from '../../utils/recoil-atoms'
import { collapsedState } from "../utils/recoil-atoms";
import { Link } from "gatsby";
// import logo from "../../assets/images/logo.png"
// import logo from "../assets/images/logo1.png";
import { fontsName } from "../assets/fonts/fontsName";
// import { AppBar, Button, Input, Toolbar, Typography } from "@material-ui/core";
// import { Add } from "@material-ui/icons";
import { /*toast, */ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
import { REQUEST_URL } from "./RequestUrl";
import { useState } from "react";
import { useEffect } from "react";

function isMobile() {
  if (typeof navigator !== "undefined") {
    // console.log({ navigator });
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  return false;
}

const FOOTER = gql`
  {
    getWebsiteFooter {
      _id
      pictureLink
      description
      address
      socialLinks
      phoneNumbers
    }
  }
`;

const MAIN_INFO_ABOUT = gql`
  {
    getWebsiteAboutUs {
      _id
      pictureLink
      description
      schoolName
      title
    }
  }
`;

const GET_REGISTER_CONFIG = gql`
	query getRegisterConfig($schoolServerName: String) {
		getRegisterConfig(schoolServerName: $schoolServerName) {
			_id
			statusRegister
			profileStudent
			authImageStudent
			mobileStudent
			moblieFather
			mobliemother
			fatherJob
			motherJob
			fatherEducation
			motherEducation
			siblings
			nameMother
			tel
			nameFather
			historyEducation
			ostan
			city
			postalCode
			address
			ghabzImage
			priceCheck
			startDate
			stopDate
			prePrice
			contractHeader
			contractTips
			contractFooter
			nationalCardF
			nationalCardM
			birthCertificateF
			birthCertificateM
			hasInsurance
			insuranceDetail
			howsLivingWith
			leftHanded
			whichChild
			socialNetworkNumberMother
			socialNetworkNumberFather
			priorSchools
			trackingCodeEnabled
			idSerialNumber
			countPerLevel {
				level
				count
				persianName
			}
			countPerRegister {
				level
				count
			}
			schoolName
			schoolServerName
			totalAmountTuition
		}
	}
`;

const GET_ALL_CONFIG = gql`
	query GetConfigInfo {
		getConfigInfo {
			_id
			version
			school_name
			school_type
			school_name_to_persian
			school_logo_link
			apollo_proxy
			level {
				level_name
				level_id
				server_name
				score_type
				final_score_type
			}
			class {
				class_name
				class_id
			}
			course_name {
				course_name
				course_id
				course_coefficient
				course_number
				goals
			}
			schoolDetail {
				ostan
				mantagheh
				shahr
				amozeshgah
				address
				emzaModir
				nameModir
			}
			terms {
				term
				start
				stop
			}
			scoreTosifi {
				score_id
				score_label
			}
			scoreNumeric {
				score_min
				score_max
			}
			scoreNumericDetail {
				label
				min
				max
			}
			maxScore
			personAccess {
				type
				media_raysaGram
				media_updateMedia
				media_live
				media_liveArchive
				sms_AllPages
				sms_Settings
				amozesh_hamkaran
				amozesh_students
				amozesh_courses
				amozesh_classes
				amozesh_term
				amozesh_grades
				gradeBook
				certificate_weekly
				certificate_monthly
				certificate_termic
				analyze
				attendance_teacher
				attendance_student
				attendance_time
				attendance_leave
				attendance_leaveCheck
				attendance_absents
				accounting_settings
				accounting_invoices
				accounting_pardakhti
				accounting_settings2
				accounting_transaction
				accounting_barasiPardakht
				accounting_pardakhtiPaye
				accounting_pardakhtiInterneti
				accounting_Pardakhtha
				accounting_pardakht
				site
				register_settings
				register_list
				register_edit
				class_control
				class_schedule
				class_onlineClass
				exam
				archive
				archive_upload
				archive_edit
				counseling
				chatroom
				personAccess
			}
		}
	}
`;

const NavbarTwo = () => {
  const [collapsed, setCollapsed] = useRecoilState(collapsedState);
  const [logo, setLogo] = React.useState("");
  const [schoolName, setSchoolName] = React.useState("");

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };
  const [isAllowRegister, setIsAllowRegister] = useState(true);
  const [isPhone, setIsPhone] = useState(false);
  const [statusRegister, setStatusRegister] = useState(false);
  const [timeStartRegister, setTimeStartRegister] = useState('');
  const [timeStopRegister, setTimeStopRegister] = useState('');
  // const [selectedTimeStartRegister, setSelectedTimeStartRegister] = useState(0);
  // const [selectedTimeStopRegister, setSelectedTimeStopRegister] = useState(0);
  // const [selectedCurrentDate, setSelectedCurrentDate] = useState(0);
  const [currentDate, setCurrentDate] = useState('');
  const [configObject, setConfigObject] = useState(null);
  const [loginText, setLoginText] = useState("ورود به پنل کاربری");

  useEffect(() => {
    request(REQUEST_URL, GET_ALL_CONFIG).then((data) => {
      if (data.getConfigInfo) {
        setConfigObject(data.getConfigInfo);
      }
    });
  }, []);

  useEffect(() => {
    setIsPhone(isMobile() ? true : false);
  }, [])

  // const {
  //   data: dataGetConfigInfo,
  //   loading: loadingGetConfigInfo,
  //   error: errorGetConfigInfo,
  // } = useQuery(GET_ALL_CONFIG, { fetchPolicy: 'network-only' });

  // useEffect(() => {
  //   if (dataGetConfigInfo) {
  //     console.log('dataGetConfigInfo:', dataGetConfigInfo);
  //     if (dataGetConfigInfo.getConfigInfo !== null) {
  //       setConfigObject(dataGetConfigInfo.getConfigInfo);
  //     }
  //   }
  // }, [dataGetConfigInfo]);
  useEffect(() => {
    if (configObject !== null) {
      fetch(`${configObject.apollo_proxy}/get_current_date`)
        .then(response => response.json())
        .then(data => {
          // console.log('date:', data);
          setCurrentDate(data.date);
        });
    }
  }, [configObject]);
  // useEffect(() => {
  //   if (timeStartRegister !== '') {
  //     var dateS = timeStartRegister.toString().split('/');
  //     var combineDateS = dateS[0] + dateS[1] + dateS[2];
  //     var NumberCombineDateS = parseInt(combineDateS);
  //     setSelectedTimeStartRegister(NumberCombineDateS);
  //   }
  // }, [timeStartRegister]);
  // useEffect(() => {
  //   if (timeStopRegister !== '') {
  //     var dateF = timeStopRegister.toString().split('/');
  //     var combineDateF = dateF[0] + dateF[1] + dateF[2];
  //     var NumberCombineDateF = parseInt(combineDateF);
  //     setSelectedTimeStopRegister(NumberCombineDateF);
  //   }
  // }, [timeStopRegister]);
  // useEffect(() => {
  //   if (currentDate !== '') {
  //     var dateC = currentDate.toString().split('/');
  //     var combineDateC = dateC[0] + dateC[1] + dateC[2];
  //     var NumberCombineDateC = parseInt(combineDateC);
  //     setSelectedCurrentDate(NumberCombineDateC);
  //   }
  // }, [currentDate]);

  // useEffect(() => {
  //     let elementId = document.getElementById("navbar");
  //     document.addEventListener("scroll", () => {
  //         if (window.scrollY > 170) {
  //             elementId.classList.add("is-sticky");
  //         } else {
  //             elementId.classList.remove("is-sticky");
  //         }
  //     });
  //     window.scrollTo(0, 0);
  // })

  useEffect(() => {
    request(REQUEST_URL, FOOTER).then((data) => {
      if (
        data.getWebsiteFooter !== null &&
        data.getWebsiteFooter.pictureLink !== null
      ) {
        setLogo(data.getWebsiteFooter.pictureLink);
      }
    });
  }, []);

  useEffect(() => {
    request(REQUEST_URL, MAIN_INFO_ABOUT).then((data) => {
      if (data.getWebsiteAboutUs) {
        setSchoolName(data.getWebsiteAboutUs.schoolName);
      }
    });
  }, []);

  // useEffect(() => {
  //   // console.log({
  //   //   selectedTimeStartRegister, selectedTimeStopRegister,
  //   //   selectedCurrentDate
  //   // })
  //   if (selectedTimeStartRegister && selectedTimeStopRegister && selectedCurrentDate) {
  //     // debugger;
  //     // if (selectedTimeStartRegister > selectedCurrentDate) {
  //     //   setIsAllowRegister(false);
  //     // }
  //     // if (selectedTimeStopRegister < selectedCurrentDate) {
  //     //   setIsAllowRegister(false);
  //     // }
  //     if (!(selectedCurrentDate >= selectedTimeStartRegister &&
  //       selectedCurrentDate <= selectedTimeStopRegister
  //     )) {
  //       setIsAllowRegister(false);
  //       // setLoginText("ورود به پنل کاربری");
  //     }
  //   }
  // }, [selectedCurrentDate, selectedTimeStartRegister, selectedTimeStopRegister]);

  useEffect(() => {
    // console.log('GET_REGISTER_CONFIG: 1');
    request(REQUEST_URL, GET_REGISTER_CONFIG).then((data) => {
      // console.log('GET_REGISTER_CONFIG: 2', data);
      if (data.getRegisterConfig) {
        // console.log('GET_REGISTER_CONFIG: 3');

        setStatusRegister(data.getRegisterConfig.statusRegister);
        setTimeStartRegister(data.getRegisterConfig.startDate);
        setTimeStopRegister(data.getRegisterConfig.stopDate);
      }
    });
  }, []);

  useEffect(() => {
    if (currentDate && timeStartRegister && timeStopRegister && statusRegister) {
      // console.log(currentDate, timeStartRegister, timeStopRegister);
      var dateS = currentDate.toString().split('/');
      var combineDateS = dateS[0] + dateS[1] + dateS[2];
      var selectedCurrentDate = parseInt(combineDateS);
      //---
      dateS = timeStartRegister.toString().split('/');
      combineDateS = dateS[0] + dateS[1] + dateS[2];
      var timeStartRegisterTemp = parseInt(combineDateS);
      //---
      dateS = timeStopRegister.toString().split('/');
      combineDateS = dateS[0] + dateS[1] + dateS[2];
      var timeStopRegisterTemp = parseInt(combineDateS);
      //---
      // console.log(selectedCurrentDate, timeStartRegisterTemp, timeStopRegisterTemp);
      //---
      if (selectedCurrentDate >= timeStartRegisterTemp &&
        selectedCurrentDate <= timeStopRegisterTemp
      ) {
        setIsAllowRegister(true);
      }
      else {
        setIsAllowRegister(false);
      }
    }
    else {
      setIsAllowRegister(false);
    }
  }, [currentDate, timeStartRegister, timeStopRegister])

  // useEffect(() => {
  //   console.log('isAllowRegister:', isAllowRegister, statusRegister);
  // }, [isAllowRegister, statusRegister]);

  const classOne = collapsed
    ? "collapse navbar-collapse"
    : "collapse navbar-collapse show";
  const classTwo = collapsed
    ? "navbar-toggler navbar-toggler-right collapsed"
    : "navbar-toggler navbar-toggler-right";
  return (
    <React.Fragment>
      <ToastContainer />
      <div id="navbar" className="navbar-area">
        <div className="tarn-nav fixed-top">
          <div style={{ /*border: "1px solid blue",*/ paddingLeft: "20px", paddingRight: "20px", paddingTop: "2px", paddingBottom: "2px", }} className="container-fluid">
            <nav style={{
              /*border: "1px solid red", */lineHeight: "1.8"
            }} className="navbar navbar-expand-lg navbar-light d-flex justify-content-between">
              {!isPhone ?
                <Link
                  style={{
                    // borderRight: "1px solid #DDD",
                    // paddingRight: "20px"
                  }}
                  // to="/"
                  // onClick={() => setCollapsed(true)}
                  className="navbar-brand"
                >
                  {logo !== "" && (
                    <img
                      src={logo || null}
                      alt="logo"
                      style={{
                        width: "80px", height: "80px",
                        // borderRight: "1px solid #DDD",
                        // paddingRight: "20px"
                      }}
                    />
                  )}

                  <span style={{ fontFamily: fontsName.VazirBold }}>
                    {schoolName}
                  </span>
                </Link>
                : <div
                  style={{
                    // borderRight: "1px solid #DDD",
                    // paddingRight: "12px"
                  }}
                  // to="/"
                  // onClick={() => setCollapsed(true)}
                  className="navbar-brand"
                >
                  {logo !== "" && (
                    <img
                      src={logo || null}
                      alt="logo"
                      style={{ width: "48px", height: "48px" }}
                    />
                  )}
                </div>}

              {isPhone && isAllowRegister ?
                <div
                  style={{
                    // height: "78px",
                    // height: CELL_SIZE_IN_MAX,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    direction: 'rtl',
                    // borderRight: "1px solid #DDD",
                    // paddingRight: "8px"
                  }}>

                  <div
                    style={{
                      // width: '100%',
                      // height: CELL_SIZE_IN_MAX,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      direction: 'rtl',
                      // // borderRight: "1px solid #DDD",
                      // paddingRight: "20px"
                    }}>
                    <Link
                      style={{
                        fontFamily: 'VazirBold', color: '#444',
                        fontSize: "14px",
                        paddingLeft: "10px",
                        textDecoration: 'underline'
                      }}
                      to="/register"
                    >
                      پیش ثبت نام
                    </Link>
                    <div style={{
                      // width: '100%',
                      // height: CELL_SIZE_IN_MAX,
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'center',
                      direction: 'rtl',
                    }}>
                      <Link
                        style={{
                          fontFamily: 'VazirBold', color: '#444',
                          fontSize: "14px",
                          paddingLeft: "10px",
                          textDecoration: 'underline'
                        }}
                        to="/tracking-register"
                      >
                        پیگیری
                      </Link>
                      <Link
                        style={{
                          fontFamily: 'VazirBold', color: '#444',
                          fontSize: "14px",
                          paddingLeft: "10px",
                          textDecoration: 'underline'
                        }}
                        to="/edit-register-info"
                      >
                        ویرایش
                      </Link>
                    </div>
                  </div>
                </div> : ""
              }

              {isPhone ?
                <div
                  style={{
                    // // borderRight: "1px solid #DDD",
                    height: "50px",
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    direction: 'rtl',
                    // paddingLeft: "20px",
                    // borderRight: "1px solid #DDD",
                    // paddingRight: "8px"
                  }}>
                  <a
                    // id="aldkvjbhfcdjslvmknfjkl"
                    href="/login"
                    // onClick={() => {
                    //   window.location.href = '/login';
                    // }}
                    // target="_blank"
                    style={{
                      fontFamily: fontsName.Vazir,
                      display: "block",
                      // width: '100%',
                      padding: "4px 8px",
                      textAlign: "center",
                      borderRadius: "10px",
                      color: "#fff",
                      backgroundColor: "#686de0",
                      fontSize: "11px",

                    }}
                  >
                    {loginText}
                  </a>
                </div>
                :
                <div style={{
                  height: "78px",
                  // width: '100%',
                  // height: CELL_SIZE_IN_MAX,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  direction: 'rtl',
                  // border: "1px solid #DDD",
                  // paddingRight: "20px",
                }}>

                  <div
                    style={{
                      // // borderRight: "1px solid #DDD",
                      height: "100%",
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      direction: 'rtl',
                      paddingLeft: "20px",
                      // borderRight: "1px solid #DDD",
                      // paddingRight: "20px",
                    }}>
                    <a
                      href="/login"
                      // target="_blank"
                      style={{
                        fontFamily: fontsName.Vazir,
                        display: "block",
                        // width: '100%',
                        paddingTop: "10px",
                        paddingBottom: "10px",
                        paddingRight: "20px",
                        paddingLeft: "20px",
                        textAlign: "center",
                        borderRadius: "10px",
                        color: "#fff",
                        backgroundColor: "#686de0",
                        fontSize: "16px",
                        // paddingRight: "20px",
                      }}
                    >
                      {loginText}
                    </a>

                  </div>

                  {isAllowRegister && (

                    <div style={{
                      // width: '100%',
                      // height: CELL_SIZE_IN_MAX,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      direction: 'rtl',
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      paddingRight: "20px",
                      paddingLeft: "20px",
                      // borderRight: "1px solid #DDD",
                      // paddingRight: "20px",
                    }}>
                      <Link
                        style={{
                          fontFamily: 'VazirBold', color: '#444',
                          textDecoration: 'underline',
                        }}
                        // className="font-medium text-20 mt-8"
                        to="/register"
                      >
                        پیش ثبت نام
                      </Link>
                      <div style={{
                        // width: '100%',
                        // height: CELL_SIZE_IN_MAX,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        direction: 'rtl',
                      }}>
                        <Link
                          style={{
                            fontFamily: 'VazirBold', color: '#444',
                            paddingLeft: "10px",
                            textDecoration: 'underline',
                          }}
                          // className="font-medium text-20 mt-8"
                          to="/tracking-register"
                        >
                          پیگیری
                        </Link>
                        <Link
                          style={{
                            fontFamily: 'VazirBold', color: '#444',
                            paddingRight: "10px",
                            textDecoration: 'underline',
                          }}
                          // className="font-medium text-20 mt-8"
                          to="/edit-register-info"
                        >
                          ویرایش
                        </Link>
                      </div>
                    </div>
                  )}


                </div>
              }

              <button
                onClick={toggleNavbar}
                className={classTwo}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="icon-bar top-bar"></span>
                <span className="icon-bar middle-bar"></span>
                <span className="icon-bar bottom-bar"></span>
              </button>

              <div className={classOne} id="navbarSupportedContent">
                <ul
                  className="navbar-nav"
                  style={{
                    fontFamily: fontsName.Vazir,
                    marginRight: "auto",
                    marginLeft: "auto",
                  }}
                >
                  <li className="nav-item">
                    <Link
                      to="/site/about-us"
                      // activeClassName="active"
                      className="nav-link"
                    >
                      <i class="fas fa-address-card"></i>
                      درباره ما
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      to="/site/chart"
                      // activeClassName="active"
                      className="nav-link"
                    >
                      <i class="fas fa-chart-bar"></i>
                      چارت سازمانی
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/site/features"
                      // activeClassName="active"
                      className="nav-link"
                    >
                      <i class="fas fa-toolbox"></i>
                      امکانات
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/site/news"
                      // activeClassName="active"
                      className="nav-link"
                    >
                      <i class="fas fa-newspaper"></i>
                      رایساگرام
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      to="/"
                      // activeClassName="active"
                      className="nav-link"
                    >
                      <i class="fas fa-home"></i>
                      خانه
                    </Link>
                  </li>
                </ul>


              </div>

            </nav>


          </div>
        </div>
      </div>
    </React.Fragment >
  );
};

export default NavbarTwo;
